export const messages = {
  en: {
    resourceAuditFlow: {
      searchTitle: 'Search Conditions',
      flowNamePlaceholder: 'Please enter flow name',
      flowTypePlaceholder: 'Please select flow type',
      query: 'Search',
      reset: 'Reset',
      listTitle: 'Approval Flow',
      add: 'Add',
      flowId: 'ID',
      flowName: 'Flow Name',
      flowType: 'Flow Type',
      flowStatus: 'Flow Status',
      createTime: 'Create Time',
      remark: 'Remark',
      operations: 'Operations',
      setFlow: 'Set Flow',
      deployFlow: 'Deploy Flow',
      edit: 'Edit',
      delete: 'Delete',
      purchaseFlow: 'Purchase Flow',
      receiveFlow: 'Receive Flow',
      transferFlow: 'Transfer Flow',
      deployed: 'Deployed',
      notDeployed: 'Not Deployed',
      flowConfigTips: [
        'Flow configuration instructions:',
        '1. The last step must be the warehouse manager, and the name must be "Warehouse Manager"',
        '2. The flow must have two or more steps'
      ],
      confirmTitle: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this approval flow?',
      cancel: 'Cancel',
      confirmDeleteBtn: 'Confirm Delete',
      addTitle: 'Add Approval Flow',
      editTitle: 'Edit Approval Flow',
      flowNameRequired: 'Flow name is required',
      flowTypeRequired: 'Flow type is required',
      remarkPlaceholder: 'Optional, max 512 characters',
      save: 'Save',
      requiredField: 'Required',
      maxLength30: 'Max 30 characters',
      maxLength12: 'Max 12 characters',
      maxLength512: 'Max 512 characters'
    }
  },
  zh: {
    resourceAuditFlow: {
      searchTitle: '查询条件',
      flowNamePlaceholder: '请输入流程名称',
      flowTypePlaceholder: '请选择流程类型',
      query: '查询',
      reset: '重置',
      listTitle: '审批流程',
      add: '添加',
      flowId: '编号',
      flowName: '流程名称',
      flowType: '流程类型',
      flowStatus: '流程状态',
      createTime: '创建时间',
      remark: '备注',
      operations: '操作',
      setFlow: '设置流程',
      deployFlow: '部署流程',
      edit: '修改',
      delete: '删除',
      purchaseFlow: '采购流程',
      receiveFlow: '领用流程',
      transferFlow: '调拨流程',
      deployed: '已部署',
      notDeployed: '待部署',
      flowConfigTips: [
        '流程配置说明：',
        '1、最后一步必须为仓库管理员，名字也必须要叫做仓库管理员',
        '2、流程必须为两步或者两步以上'
      ],
      confirmTitle: '请确认您的操作',
      confirmDelete: '确定删除审批流程?',
      cancel: '点错了',
      confirmDeleteBtn: '确认删除',
      addTitle: '添加审批流程',
      editTitle: '修改审批流程',
      flowNameRequired: '流程名称不能为空',
      flowTypeRequired: '流程类型不能为空',
      remarkPlaceholder: '选填，最多512个字符',
      save: '保存',
      requiredField: '必填项',
      maxLength30: '不能超过30个字符',
      maxLength12: '不能超过12个字符',
      maxLength512: '不能超过512个字符'
    }
  },
  'zh-TW': {
    resourceAuditFlow: {
      searchTitle: '查詢條件',
      flowNamePlaceholder: '請輸入流程名稱',
      flowTypePlaceholder: '請選擇流程類型',
      query: '查詢',
      reset: '重設',
      listTitle: '審批流程',
      add: '添加',
      flowId: '編號',
      flowName: '流程名稱',
      flowType: '流程類型',
      flowStatus: '流程狀態',
      createTime: '創建時間',
      remark: '備註',
      operations: '操作',
      setFlow: '設置流程',
      deployFlow: '部署流程',
      edit: '修改',
      delete: '刪除',
      purchaseFlow: '採購流程',
      receiveFlow: '領用流程',
      transferFlow: '調撥流程',
      deployed: '已部署',
      notDeployed: '待部署',
      flowConfigTips: [
        '流程配置說明：',
        '1的最後一步必須為倉庫管理員，名稱也必須要叫做倉庫管理員',
        '2、流程必須為兩步或者兩步以上'
      ],
      confirmTitle: '請確認您的操作',
      confirmDelete: '確定刪除審批流程?',
      cancel: '點錯了',
      confirmDeleteBtn: '確認刪除',
      addTitle: '添加審批流程',
      editTitle: '修改審批流程',
      flowNameRequired: '流程名稱不能為空',
      flowTypeRequired: '流程類型不能為空',
      remarkPlaceholder: '選填，最多512個字符',
      save: '保存',
      requiredField: '必填項',
      maxLength30: '不能超過30個字符',
      maxLength12: '不能超過12個字符',
      maxLength512: '不能超過512個字符'
    }
  }
}
